// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RegistrationTradePoint_mainWrapper__9jtQX {
    height: -moz-fit-content;
    height: fit-content;
    padding: 0 10px;
  }
  
  .RegistrationTradePoint_formWrapper__Pue4m {
    padding-top: 20px;
    padding-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    overflow-y: scroll;
  }
  
  .RegistrationTradePoint_registrationTitle__A\\+hPT {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 24px;
    max-width: 1080px;
  }
  
  .RegistrationTradePoint_registrationConfigRoot__WP4Rf {
    background-color: #fff;
    width: 100%;
    border-radius: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 5px 16px;
  }
  
  .RegistrationTradePoint_labelAndButtonWrapper__n-h\\+K {
    display: flex;

    overflow: visible;
    align-items: center;
    margin-bottom: 2px;
    gap: 10px;
  }
  
  .RegistrationTradePoint_titleWrapper__I8xhG {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
  }
  
  .RegistrationTradePoint_checkboxWraper__DsKls {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
    margin-bottom: 10px;
    gap: 8px;
  }
  
  .RegistrationTradePoint_labelCheckBox__K\\+4Z5 {
    font-size: 14px;
    font-weight: 500;
  }
  
  .RegistrationTradePoint_labelAndErrorWrapper__eunSj {
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    align-items: center;
  }
  
  .RegistrationTradePoint_orgTitleMain__ylTg1 {
    font-weight: 600;
  }
  
  @media screen and (max-width: 600px) {
    .RegistrationTradePoint_label-and-error-wrapper__JBcpw {
      margin-top: 10px;
    }
  }
  
  .RegistrationTradePoint_subjectBlockConfigRoot__Sg\\+qG {
    background-color: #fff;
    width: 100%;
    border-radius: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 12px 16px;
    margin-bottom: 12px;
  }
  
  .RegistrationTradePoint_blockConfigRoot__iynNK {
    background-color: #fff;
    padding-top: 16px;
    gap: 10px;
    width: 100%;
  }
  
  .RegistrationTradePoint_buttonBlock__xB1Kz {
    display: flex;
    justify-content: flex-start;
    gap: 10px;
    max-width: 100%;
    margin-bottom: 16px;
  }
  
  .RegistrationTradePoint_buttonConfigRoot__Q6vEQ {
    background-color: #fff;
    border-radius: 8px;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .RegistrationTradePoint_formAddButton__mGwA- {
    background-color: #fff;
    width: 100%;
    border-radius: 8px;
    padding: 10px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
  
  .RegistrationTradePoint_formAddButton__mGwA- span {
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
  }
  
  .RegistrationTradePoint_formAddButton__mGwA- img {
    flex-shrink: 0;
  }
  
  .RegistrationTradePoint_formAddButton__mGwA-:hover {
    background-color: #f3f7f7;
  }
  
  .RegistrationTradePoint_formButton__aO\\+2U {
    display: flex;
    flex-direction: row;
    max-width: 100%;
    gap: 8px;
  }
  
  .RegistrationTradePoint_inputField__beKkT {
    /* max-width: 256px; */
    /* flex: 1 1 calc(50% - 10px); */
    /* max-width: calc(50% - 8px); */
    font-family: "Inter", sans-serif;
    font-weight: 500;
    line-height: 19.6px;
    color: #2e3138;
    margin-bottom: 8px;
    max-width: calc(33% - 20px);
    /* flex: 1 1 calc(50% - 10px); */
    width: 100%;
    min-width: 150px;
  }
  .RegistrationTradePoint_inputField2__C1zOw {
    /* max-width: 256px; */
    /* flex: 1 1 calc(50% - 10px); */
    /* max-width: calc(50% - 8px); */
    font-family: "Inter", sans-serif;
    font-weight: 500;
    line-height: 19.6px;
    color: #2e3138;
    margin-bottom: 8px;
    max-width: calc(50% - 20px);
    /* flex: 1 1 calc(50% - 10px); */
    width: 100%;
    min-width: 150px;
  }
  
  .RegistrationTradePoint_inputField1__MG8UN {
    font-family: "Inter", sans-serif;
    font-weight: 500;
    line-height: 19.6px;
    color: #2e3138;
    margin-bottom: 8px;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33% - 10px);
    width: 100%;
    min-width: 150px;
  }

  .RegistrationTradePoint_inputField3__pm6wi {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(25% - 15px);
  }
  
  /* Стили для обычных инпутов */
  .RegistrationTradePoint_inputField1__MG8UN input:not([class*="select"]) {
    width: 100%;
    height: 40px;
    border: 1px solid #a3c0d2;
    border-radius: 10px;
    padding-left: 10px;
    font-size: 14px;
    color: #2e3138;
    font-family: "Inter", sans-serif;
    font-weight: 500;
    line-height: 19.6px;
    margin: 0;
    outline: none;
  }
  
  /* Убираем стили для селекта */
  .RegistrationTradePoint_inputField1__MG8UN .RegistrationTradePoint_select__control__qJ4OT {
    border: none !important;
    box-shadow: none !important;
  }
  
  .RegistrationTradePoint_selectField__ZCAnd {
    width: 100%;
    height: 48px;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33% - 20px);
    padding: 8px;
    margin: 0;
    border: 1px solid #a3c0d2;
    border-radius: 10px;
    
  }
  
  .RegistrationTradePoint_inputField__beKkT .RegistrationTradePoint_placeholder__ibN2P,
  .RegistrationTradePoint_inputField__beKkT input {
    width: 100%;
    height: 40px;
    border: 1px solid #a3c0d2;
    border-radius: 10px;
    padding-left: 10px;
    font-size: 12px;
    color: #2e3138;
    font-family: "Inter", sans-serif;
    font-weight: 500;
    line-height: 19.6px;
    margin: 0;
    outline: none;
  }
  .RegistrationTradePoint_inputField2__C1zOw .RegistrationTradePoint_placeholder__ibN2P,
  .RegistrationTradePoint_inputField2__C1zOw input {
    width: 100%;
    height: 40px;
    border: 1px solid #a3c0d2;
    border-radius: 10px;
    padding-left: 10px;
    font-size: 12px;
    color: #2e3138;
    font-family: "Inter", sans-serif;
    font-weight: 500;
    line-height: 19.6px;
    margin: 0;
    outline: none;
  }
  .RegistrationTradePoint_inputlabel2__3DPRF {
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    width: 100%;
    padding: 20px;
  }
  .RegistrationTradePoint_inputlabel2__3DPRF ::placeholder{
    color: red;
  }
  
  .RegistrationTradePoint_inputField__beKkT input:hover {
    border-color: #8ea3b0;
  }
  
  .RegistrationTradePoint_inputField__beKkT input:focus {
    border-color: #0c6154;
    border-width: 1px;
  }
  
  .RegistrationTradePoint_inputField__beKkT input::placeholder {
    color: #a3c0d2;
    font-weight: 400;
    font-size: 14px;
  }
  
  .RegistrationTradePoint_inputField__beKkT input.RegistrationTradePoint_-error__yLzKI {
    border-color: #ed1e1e;
  }
  
  .RegistrationTradePoint_inputField1__MG8UN input:hover {
    border-color: #8ea3b0;
  }
  
  .RegistrationTradePoint_inputField1__MG8UN input:focus {
    border-color: #0c6154;
    border-width: 1px;
  }
  
  .RegistrationTradePoint_inputField1__MG8UN input::placeholder {
    color: #a3c0d2;
    font-weight: 400;
    font-size: 14px;
  }
  
  .RegistrationTradePoint_inputField1__MG8UN input.RegistrationTradePoint_-error__yLzKI {
    border-color: #ed1e1e;
  }
  
  .RegistrationTradePoint_buttonForm__Pc-vp {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33% - 8px);
  }
  
  .RegistrationTradePoint_errorLabel__6POEx {
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    color: rgb(249, 52, 30);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .RegistrationTradePoint_labelAndErrorWrapper__eunSj {
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    align-items: center;
  }
  
  .RegistrationTradePoint_activeButton__JUXSF {
    font-weight: bold;
    font-size: 14px;
    line-height: 125%;
    color: #0c6154;
    text-decoration: underline;
    text-underline-offset: 4px;
  }
  
  .RegistrationTradePoint_tooltipWrapper__pENCF {
    position: relative;
    display: inline-block;
    cursor: pointer; 
  }
  
  .RegistrationTradePoint_tooltipText__9-74A {
    visibility: hidden; 
    width: 150px;
    background-color: rgba(0, 0, 0, 0.75); 
    color: #fff; 
    text-align: center;
    border-radius: 4px; 
    padding: 5px 10px; 
    position: absolute;
    z-index: 10; 
    bottom: 125%; 
    left: 50%;
    transform: translateX(-50%);
    opacity: 0; 
    transition: opacity 0.3s ease-in-out;
    font-size: 12px;
    pointer-events: none; 
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3); 
  }
  
  .RegistrationTradePoint_tooltipWrapper__pENCF:hover .RegistrationTradePoint_tooltipText__9-74A {
    visibility: visible;
    opacity: 1;
    position: absolute;
  }
  
  .RegistrationTradePoint_errorIcon__q-4Em {
    color: red; /* Цвет иконки */
    width: 16px; /* Размер иконки */
    height: 13px;
    display: inline-block;
  }
  
  
  `, "",{"version":3,"sources":["webpack://./src/pages/RegistrationTradePoint/index.module.css"],"names":[],"mappings":"AAAA;IACI,wBAAmB;IAAnB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,aAAa;EACf;;EAEA;IACE,aAAa;;IAEb,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,SAAS;IACT,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,2BAA2B;IAC3B,gCAAgC;IAChC,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,2BAA2B;IAC3B,gCAAgC;IAChC,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;EAC5B;;EAEA,8BAA8B;EAC9B;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,aAAa;EACf;;EAEA,8BAA8B;EAC9B;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,YAAY;IACZ,SAAS;IACT,yBAAyB;IACzB,mBAAmB;;EAErB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,aAAa;EACf;EACA;;IAEE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,aAAa;EACf;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,aAAa;EACf;EACA;IACE,UAAU;EACZ;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,qCAAqC;IACrC,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,oCAAoC;IACpC,eAAe;IACf,oBAAoB;IACpB,0CAA0C;EAC5C;;EAEA;IACE,mBAAmB;IACnB,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,UAAU,EAAE,gBAAgB;IAC5B,WAAW,EAAE,kBAAkB;IAC/B,YAAY;IACZ,qBAAqB;EACvB","sourcesContent":[".mainWrapper {\n    height: fit-content;\n    padding: 0 10px;\n  }\n  \n  .formWrapper {\n    padding-top: 20px;\n    padding-bottom: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 100vh;\n    overflow-y: scroll;\n  }\n  \n  .registrationTitle {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 0 24px;\n    max-width: 1080px;\n  }\n  \n  .registrationConfigRoot {\n    background-color: #fff;\n    width: 100%;\n    border-radius: 8px;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 5px 16px;\n  }\n  \n  .labelAndButtonWrapper {\n    display: flex;\n\n    overflow: visible;\n    align-items: center;\n    margin-bottom: 2px;\n    gap: 10px;\n  }\n  \n  .titleWrapper {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 8px;\n  }\n  \n  .checkboxWraper {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    gap: 8px;\n  }\n  \n  .labelCheckBox {\n    font-size: 14px;\n    font-weight: 500;\n  }\n  \n  .labelAndErrorWrapper {\n    display: flex;\n    justify-content: space-between;\n    overflow: hidden;\n    align-items: center;\n  }\n  \n  .orgTitleMain {\n    font-weight: 600;\n  }\n  \n  @media screen and (max-width: 600px) {\n    .label-and-error-wrapper {\n      margin-top: 10px;\n    }\n  }\n  \n  .subjectBlockConfigRoot {\n    background-color: #fff;\n    width: 100%;\n    border-radius: 8px;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px 16px;\n    margin-bottom: 12px;\n  }\n  \n  .blockConfigRoot {\n    background-color: #fff;\n    padding-top: 16px;\n    gap: 10px;\n    width: 100%;\n  }\n  \n  .buttonBlock {\n    display: flex;\n    justify-content: flex-start;\n    gap: 10px;\n    max-width: 100%;\n    margin-bottom: 16px;\n  }\n  \n  .buttonConfigRoot {\n    background-color: #fff;\n    border-radius: 8px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  \n  .formAddButton {\n    background-color: #fff;\n    width: 100%;\n    border-radius: 8px;\n    padding: 10px 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n  }\n  \n  .formAddButton span {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 100%;\n    overflow: hidden;\n  }\n  \n  .formAddButton img {\n    flex-shrink: 0;\n  }\n  \n  .formAddButton:hover {\n    background-color: #f3f7f7;\n  }\n  \n  .formButton {\n    display: flex;\n    flex-direction: row;\n    max-width: 100%;\n    gap: 8px;\n  }\n  \n  .inputField {\n    /* max-width: 256px; */\n    /* flex: 1 1 calc(50% - 10px); */\n    /* max-width: calc(50% - 8px); */\n    font-family: \"Inter\", sans-serif;\n    font-weight: 500;\n    line-height: 19.6px;\n    color: #2e3138;\n    margin-bottom: 8px;\n    max-width: calc(33% - 20px);\n    /* flex: 1 1 calc(50% - 10px); */\n    width: 100%;\n    min-width: 150px;\n  }\n  .inputField2 {\n    /* max-width: 256px; */\n    /* flex: 1 1 calc(50% - 10px); */\n    /* max-width: calc(50% - 8px); */\n    font-family: \"Inter\", sans-serif;\n    font-weight: 500;\n    line-height: 19.6px;\n    color: #2e3138;\n    margin-bottom: 8px;\n    max-width: calc(50% - 20px);\n    /* flex: 1 1 calc(50% - 10px); */\n    width: 100%;\n    min-width: 150px;\n  }\n  \n  .inputField1 {\n    font-family: \"Inter\", sans-serif;\n    font-weight: 500;\n    line-height: 19.6px;\n    color: #2e3138;\n    margin-bottom: 8px;\n    flex: 1 1 calc(33% - 10px);\n    width: 100%;\n    min-width: 150px;\n  }\n\n  .inputField3 {\n    flex: 1 1 calc(25% - 15px);\n  }\n  \n  /* Стили для обычных инпутов */\n  .inputField1 input:not([class*=\"select\"]) {\n    width: 100%;\n    height: 40px;\n    border: 1px solid #a3c0d2;\n    border-radius: 10px;\n    padding-left: 10px;\n    font-size: 14px;\n    color: #2e3138;\n    font-family: \"Inter\", sans-serif;\n    font-weight: 500;\n    line-height: 19.6px;\n    margin: 0;\n    outline: none;\n  }\n  \n  /* Убираем стили для селекта */\n  .inputField1 .select__control {\n    border: none !important;\n    box-shadow: none !important;\n  }\n  \n  .selectField {\n    width: 100%;\n    height: 48px;\n    flex: 1 1 calc(33% - 20px);\n    padding: 8px;\n    margin: 0;\n    border: 1px solid #a3c0d2;\n    border-radius: 10px;\n    \n  }\n  \n  .inputField .placeholder,\n  .inputField input {\n    width: 100%;\n    height: 40px;\n    border: 1px solid #a3c0d2;\n    border-radius: 10px;\n    padding-left: 10px;\n    font-size: 12px;\n    color: #2e3138;\n    font-family: \"Inter\", sans-serif;\n    font-weight: 500;\n    line-height: 19.6px;\n    margin: 0;\n    outline: none;\n  }\n  .inputField2 .placeholder,\n  .inputField2 input {\n    width: 100%;\n    height: 40px;\n    border: 1px solid #a3c0d2;\n    border-radius: 10px;\n    padding-left: 10px;\n    font-size: 12px;\n    color: #2e3138;\n    font-family: \"Inter\", sans-serif;\n    font-weight: 500;\n    line-height: 19.6px;\n    margin: 0;\n    outline: none;\n  }\n  .inputlabel2 {\n    font-size: 12px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100%;\n    width: 100%;\n    padding: 20px;\n  }\n  .inputlabel2 ::placeholder{\n    color: red;\n  }\n  \n  .inputField input:hover {\n    border-color: #8ea3b0;\n  }\n  \n  .inputField input:focus {\n    border-color: #0c6154;\n    border-width: 1px;\n  }\n  \n  .inputField input::placeholder {\n    color: #a3c0d2;\n    font-weight: 400;\n    font-size: 14px;\n  }\n  \n  .inputField input.-error {\n    border-color: #ed1e1e;\n  }\n  \n  .inputField1 input:hover {\n    border-color: #8ea3b0;\n  }\n  \n  .inputField1 input:focus {\n    border-color: #0c6154;\n    border-width: 1px;\n  }\n  \n  .inputField1 input::placeholder {\n    color: #a3c0d2;\n    font-weight: 400;\n    font-size: 14px;\n  }\n  \n  .inputField1 input.-error {\n    border-color: #ed1e1e;\n  }\n  \n  .buttonForm {\n    flex: 1 1 calc(33% - 8px);\n  }\n  \n  .errorLabel {\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 14px;\n    color: rgb(249, 52, 30);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  \n  .labelAndErrorWrapper {\n    display: flex;\n    justify-content: space-between;\n    overflow: hidden;\n    align-items: center;\n  }\n  \n  .activeButton {\n    font-weight: bold;\n    font-size: 14px;\n    line-height: 125%;\n    color: #0c6154;\n    text-decoration: underline;\n    text-underline-offset: 4px;\n  }\n  \n  .tooltipWrapper {\n    position: relative;\n    display: inline-block;\n    cursor: pointer; \n  }\n  \n  .tooltipText {\n    visibility: hidden; \n    width: 150px;\n    background-color: rgba(0, 0, 0, 0.75); \n    color: #fff; \n    text-align: center;\n    border-radius: 4px; \n    padding: 5px 10px; \n    position: absolute;\n    z-index: 10; \n    bottom: 125%; \n    left: 50%;\n    transform: translateX(-50%);\n    opacity: 0; \n    transition: opacity 0.3s ease-in-out;\n    font-size: 12px;\n    pointer-events: none; \n    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3); \n  }\n  \n  .tooltipWrapper:hover .tooltipText {\n    visibility: visible;\n    opacity: 1;\n    position: absolute;\n  }\n  \n  .errorIcon {\n    color: red; /* Цвет иконки */\n    width: 16px; /* Размер иконки */\n    height: 13px;\n    display: inline-block;\n  }\n  \n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainWrapper": `RegistrationTradePoint_mainWrapper__9jtQX`,
	"formWrapper": `RegistrationTradePoint_formWrapper__Pue4m`,
	"registrationTitle": `RegistrationTradePoint_registrationTitle__A+hPT`,
	"registrationConfigRoot": `RegistrationTradePoint_registrationConfigRoot__WP4Rf`,
	"labelAndButtonWrapper": `RegistrationTradePoint_labelAndButtonWrapper__n-h+K`,
	"titleWrapper": `RegistrationTradePoint_titleWrapper__I8xhG`,
	"checkboxWraper": `RegistrationTradePoint_checkboxWraper__DsKls`,
	"labelCheckBox": `RegistrationTradePoint_labelCheckBox__K+4Z5`,
	"labelAndErrorWrapper": `RegistrationTradePoint_labelAndErrorWrapper__eunSj`,
	"orgTitleMain": `RegistrationTradePoint_orgTitleMain__ylTg1`,
	"label-and-error-wrapper": `RegistrationTradePoint_label-and-error-wrapper__JBcpw`,
	"subjectBlockConfigRoot": `RegistrationTradePoint_subjectBlockConfigRoot__Sg+qG`,
	"blockConfigRoot": `RegistrationTradePoint_blockConfigRoot__iynNK`,
	"buttonBlock": `RegistrationTradePoint_buttonBlock__xB1Kz`,
	"buttonConfigRoot": `RegistrationTradePoint_buttonConfigRoot__Q6vEQ`,
	"formAddButton": `RegistrationTradePoint_formAddButton__mGwA-`,
	"formButton": `RegistrationTradePoint_formButton__aO+2U`,
	"inputField": `RegistrationTradePoint_inputField__beKkT`,
	"inputField2": `RegistrationTradePoint_inputField2__C1zOw`,
	"inputField1": `RegistrationTradePoint_inputField1__MG8UN`,
	"inputField3": `RegistrationTradePoint_inputField3__pm6wi`,
	"select__control": `RegistrationTradePoint_select__control__qJ4OT`,
	"selectField": `RegistrationTradePoint_selectField__ZCAnd`,
	"placeholder": `RegistrationTradePoint_placeholder__ibN2P`,
	"inputlabel2": `RegistrationTradePoint_inputlabel2__3DPRF`,
	"-error": `RegistrationTradePoint_-error__yLzKI`,
	"buttonForm": `RegistrationTradePoint_buttonForm__Pc-vp`,
	"errorLabel": `RegistrationTradePoint_errorLabel__6POEx`,
	"activeButton": `RegistrationTradePoint_activeButton__JUXSF`,
	"tooltipWrapper": `RegistrationTradePoint_tooltipWrapper__pENCF`,
	"tooltipText": `RegistrationTradePoint_tooltipText__9-74A`,
	"errorIcon": `RegistrationTradePoint_errorIcon__q-4Em`
};
export default ___CSS_LOADER_EXPORT___;
